export default {
  badge: 'نشان',
  close: 'بستن',
  dataIterator: {
    noResultsText: 'نتیجه‌ای یافت نشد',
    loadingText: 'در حال بارگذاری...',
  },
  dataTable: {
    itemsPerPageText: 'ردیف در صفحه:',
    ariaLabel: {
      sortDescending: ': نزولی مرتب شده است. فعال‌سازی برای حذف مرتب‌سازی.',
      sortAscending: ': صعودی مرتب شده است. فعال‌سازی برای مرتب‌سازی نزولی.',
      sortNone: ': مرتب نشده است. فعال‌سازی برای مرتب‌سازی صعودی.',
    },
    sortBy: 'مرتب‌سازی براساس',
  },
  dataFooter: {
    itemsPerPageText: 'ردیف در صفحه:',
    itemsPerPageAll: 'همه',
    nextPage: 'صفحه‌ی بعد',
    prevPage: 'صفحه‌ی قبل',
    firstPage: 'صفحه‌ی اول',
    lastPage: 'صفحه‌ی آخر',
    pageText: '{0} تا {1} از {2}',
  },
  datePicker: {
    itemsSelected: '{0} انتخاب شده است',
  },
  noDataText: 'اطلاعاتی یافت نشد',
  carousel: {
    prev: 'اسلاید قبلی',
    next: 'اسلاید بعدی',
    ariaLabel: {
      delimiter: 'Carousel slide {0} of {1}',
    },
  },
  calendar: {
    moreEvents: '{بیشتر {0',
  },
  fileInput: {
    counter: '{0} پرونده',
    counterSize: '{0} پرونده ({1} در کل)',
  },
  timePicker: {
    am: 'قبل از ظهر',
    pm: 'بعد از ظهر',
  },
}
